<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green my-row">
          <div class="card-icon">
            <md-icon>sports_esports</md-icon>
          </div>
          <h4 class="title">Доступные аппараты</h4>

          <md-button class="my-md-button md-success" @click.native="load()">
            <span class="material-icons"> refresh </span>
            Обновить
          </md-button>
        </md-card-header>
        <md-card-content v-if="isApvs">
          <div>Нет сообщений</div>
        </md-card-content>
        <md-card-content v-else>
          <!-- <pagination
            class="pagination-no-border pagination-success"
            v-model="currentPage"
            :per-page="perPage"
            :total="queryLength"
          >
          </pagination> -->

          <mess-card
            v-for="item in model"
            :key="item.sn"
            :item="item"
            @needToRefresh="load()"
          ></mess-card>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import MessCard from "../components/EngMessages/MessCard.vue";
// import { Pagination } from "@/components";

export default {
  // components: { MessCard, Pagination },
  components: { MessCard },
  computed: {
    isApvs() {
      if (this.model.length == 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      model: [],
    };
  },
  methods: {
    load() {
      this.ajax.getEngMessages(
        this,
        {},
        (r) => {
          if (r.status == "ok") {
            this.model = r.data;
          } else {
            this.showErrorNotify(r);
          }
        },
        (err) => {
          //console.log(err);
        }
      );
    },
  },
  mounted() {
    this.load();
  },
  watch: {},
};
</script>

<style lang="css" scoped>
.md-tabs {
  margin-bottom: 24px;
}

.material-icons {
  margin-right: 15px;
}

.my-md-button {
  width: 200px;
  height: 41px;
  margin-top: 10px;
  margin-left: 30px;
}

.my-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
</style>
